import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

import cancelled from '../../images/icons/cancelled.svg'
import { useLocation } from 'react-router-dom'
import Vignette from './Vignette'
import { useSearchParam } from 'hooks/useSearchParams'

export default function SideDrawer({ children, drawerOpen, toggle, classes }) {
  const location = useLocation()
  const { clearMany } = useSearchParam()
  drawerOpen = drawerOpen ?? location.search.includes('drawer-open=true')

  useEffect(() => {
    toggle(location.search.includes('drawer-open=true'))
  }, [location, toggle])

  useEffect(() => {
    if (drawerOpen) {
      if (window.innerWidth > 975) {
        // remove scrolling on background divs when menu is open
        document.querySelector('html').style = 'overflow: hidden'
      }
    } else {
      // reactivate scrolling
      document.querySelector('html').style = ''
    }

    return () => {
      document.querySelector('html').style = ''
    }
  }, [drawerOpen])

  return (
    <>
      <div
        id="side-drawer"
        className={`side-drawer_wrapper ${classes} ${drawerOpen ? 'open' : ''}`}
      >
        {drawerOpen && (
          <>
            <section id="side-drawer-content" className="side-drawer_content">
              {children}
              <button
                type="button"
                onClick={() => {
                  clearMany(['drawer-open', 'event-id', 'step'])
                }}
                className="side-drawer_close-btn_wrapper"
              >
                <img src={cancelled} alt="close-menu" className="side-drawer_close-btn_icon" />
              </button>
            </section>
          </>
        )}
      </div>
      <Vignette visible={drawerOpen} fullScreen clearParams={['drawer-open', 'event-id', 'step']} />
    </>
  )
}

SideDrawer.propTypes = {
  children: PropTypes.node.isRequired,
  drawerOpen: PropTypes.bool,
  toggle: PropTypes.func.isRequired,
  classes: PropTypes.string,
}
